<div class="parking-process-list-container">
    <!-- Loading State -->
    @if (isLoading) {
    <div class="flex flex-col items-center justify-center py-12 space-y-4">
        <mat-spinner diameter="50"></mat-spinner>
        <div class="text-center">
            <h3 class="text-lg font-medium text-gray-900 mb-2">Loading parking processes...</h3>
            <p class="text-gray-500">Please wait while we fetch the data.</p>
        </div>
    </div>
    }

    <!-- Processes List -->
    @else if (processes && processes.length > 0) {
    <div class="space-y-4">
        <!-- Mobile Layout (Single Column) -->
        @if (isHandset()) {
        <div class="space-y-3">
            @for (process of paginatedProcesses; track process.id) {
            <app-parking-zone-parking-process-item [process]="process" (clicked)="onProcessClick($event)">
            </app-parking-zone-parking-process-item>
            }
        </div>
        }

        <!-- Desktop/Tablet Layout (Grid) -->
        @else {
        <div class="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4">
            @for (process of paginatedProcesses; track process.id) {
            <app-parking-zone-parking-process-item [process]="process" (clicked)="onProcessClick($event)">
            </app-parking-zone-parking-process-item>
            }
        </div>
        }

        <!-- Pagination -->
        @if (processes.length > pageSize) {
        <div class="flex justify-center mt-6 pt-6 border-t border-gray-200">
            <mat-paginator [length]="processes.length" [pageSize]="pageSize" [pageIndex]="pageIndex"
                [pageSizeOptions]="[10, 20, 50]" [showFirstLastButtons]="!isHandset()" (page)="onPageChange($event)"
                class="bg-transparent">
            </mat-paginator>
        </div>
        }
    </div>
    }

    <!-- Empty State -->
    @else {
    <div class="text-center py-12">
        <div class="flex flex-col items-center space-y-4">
            <mat-icon class="text-6xl text-gray-400">local_parking</mat-icon>
            <div class="space-y-2">
                <h3 class="text-lg font-medium text-gray-900">No parking processes found</h3>
                <p class="text-gray-500 max-w-sm">
                    There are no parking processes matching the current filter for this zone.
                </p>
            </div>
        </div>
    </div>
    }
</div>